<style scoped>

  #colors-segment {
    min-height: 365px;
  }

  #price-segment {
    min-height: 365px;
  }  

  .tooltip-icon {
    display: inline-block;
  }

  .tooltip-icon i {
    font-size: 14px;
  }

  .readonly-field {
    display: block;
    padding: .67857143em 1em;
    background: #fff;
    border: 1px solid rgba(34,36,38,.15);
    border-radius: .28571429rem;
    color: rgba(0,0,0,.87);
    line-height: 1.21428571em;
    min-height: 2.71428571em;
  }

</style>

<template>

  <div class="ui segment animated fadeIn" :class="{ loading }">

    <closeable-header-label :label="headerLabel" @onClose="onCancel()" />

    <div class="ui grid m-t-5">      

      <div v-if="!quotation.isRetail" class="eight wide column" style="padding-bottom: 0px !important;">
        <div v-if="item.idReserve" class="ui small label animated fadeIn">
          <i class="info circle icon"></i>Utilizando a reserva {{ item.idReserve }}
        </div>
        <button v-else class="ui icon mini basic button" @click="$refs.reservePicker.show()">
          <i class="lock blue icon"></i> Selecionar reserva
        </button>
      </div>

      <div v-if="infoLabel" class="eight wide column" style="padding-bottom: 0px !important;">
        <div class="ui basic right aligned segment no-margin no-padding">
          <div class="ui small label animated fadeIn">
            <i class="info circle icon"></i> {{ infoLabel }}
          </div>
        </div>
      </div>

      <div class="sixteen wide column">
        <div class="ui segment">
          <h4 class="ui dividing header">Produto</h4>
          <form class="ui form">
            <div v-show="!item.idReserve" class="fields">              
              <div class="seven wide field" :class="{ disabled: !canChangeProps }">
                <label class="form-label">Produto <span class="red text">*</span></label>
                <select id="select-product" class="ui fluid search dropdown">
                </select>
              </div>
              <div class="three wide field" :class="{ disabled: !canChangeProps }">
                <label class="form-label">Bitola <span class="red text">*</span></label>
                <select id="select-bitola" class="ui fluid search dropdown">
                </select>
              </div>
              <div class="six wide field" :class="{ disabled: !canChangeProps }">
                <label class="form-label">Acondicionamento <span class="red text">*</span></label>
                <select id="select-package" class="ui fluid dropdown">
                </select>
              </div>              
            </div>
            <div class="fields">
              <div v-show="!item.idReserve" class="three wide field" :class="{ disabled: !canChangeProps }">
                <label class="form-label">
                  Metragem <span class="red text m-r-5">*</span>
                  <i v-if="item.amountPackage && !item.isSpecificPackageAmount" class="check circle green icon"></i>
                  <i v-if="item.isSpecificPackageAmount" class="exclamation circle red icon"></i>
                </label>
                <select id="select-meters" class="ui fluid dropdown">
                </select>
              </div>
              <div v-show="!item.idReserve && item.isSpecificPackageAmount" class="three wide field" :class="{ disabled: !canChangeProps }">
                <label class="form-label">Metragem Específica <span class="red text">*</span></label>
                <input id="input-amount-package" class="integer" :value="amountPackage" @blur="amountPackage = $event.target.value">
              </div>
              <div v-show="!item.idReserve" class="four wide field" :class="{ disabled: !canChangeProps }">
                <label class="form-label">
                  Especialidade <span class="red text m-r-5">*</span>
                  <i v-if="item.specialty && item.specialty == '01'" class="check circle green icon"></i>
                  <i v-if="item.specialty && item.specialty != '01'" class="exclamation circle red icon"></i>
                </label>
                <select id="select-specialty" class="ui fluid dropdown">
                </select>
              </div>
              <div v-show="item.idReserve" class="eleven wide field">
                <label class="form-label">Produto</label>
                <input type="text" :value="item.description" readonly="readonly">
              </div>
              <div class="three wide field">
                <label class="form-label">Pedido do Cliente</label>
                <input type="text" v-model="item.customerSalesOrder">
              </div>
              <div class="two wide field">
                <label class="form-label">Item ped. cliente</label>
                <input type="text" v-model="item.itemCustomerSalesOrder">
              </div>
              
              <!--Novo campo para aceitar tolerancia (2025.05.23) pedido Rafael-->
              <div class="two wide field" :class="{ error: toleranceFieldHasError }">
                <label class="form-label">
                  Aceita Tolerância <span class="red text">*</span>
                  <span 
                    class="tooltip-icon" 
                    :title="'Ao definir como Sim o cliente aceita receber a bobina com desvio de até 3% no lance'"
                    style="cursor: help; margin-left: 5px;"
                  >
                    <i class="question circle blue icon"></i>
                  </span>
                </label>
                <select 
                  v-model="item.itemAcceptTolerance" 
                  class="ui fluid dropdown"
                  :class="{ disabled: !canEditTolerance }"
                  :disabled="!canEditTolerance"
                  @change="toleranceFieldHasError = false"
                  id="select-tolerance"
                >
                  <!-- A opção nula força a escolha do usuário -->
                  <option :value="null" disabled>Selecione...</option>
                  <option value="N">Não</option>
                  <option value="S">Sim</option>
                </select>
              </div>
              <!---->

            </div>            
          </form>
        </div>
      </div>

      <div class="eight wide computer sixteen wide tablet sixteen wide mobile column">
        <div id="colors-segment" class="ui segment">
          <h4 class="ui dividing header">
            Cores
            <span v-if="colorsRequireApproval" class="ui small label animated fadeIn">
              <i class="info circle icon"></i>  Uma ou mais cores precisam ser aprovadas
            </span>
          </h4>
          <div v-show="!item.idReserve">
            <form class="ui form">
              <div class="fields">
                <div class="eleven wide field">
                  <label class="form-label">Cor <span class="red text">*</span></label>
                  <select id="select-colors" class="ui fluid search dropdown">
                  </select>
                </div>
                <div class="five wide field">
                  <label class="form-label">Quantidade <span class="red text">*</span></label>
                  <div class="ui action input" :class="{ disabled: !selectedColor }">
                    <input id="input-color-quantity" class="integer" :value="colorQuantity" @blur="colorQuantity = $event.target.value">
                    <button type="button" class="ui basic icon button" @click="onAddColor()">
                      <i class="arrow down blue icon"></i>
                    </button>
                  </div>
                </div>
                <div class="five wide field" v-if="userIsSpecial()">
                  <label class="form-label">P. O. Shipment </label>
                  <input id="input-poShip" class="integer" :value="poShipment" @blur="poShipment = $event.target.value">
                </div>
              </div>
            </form>
            <button v-if="qtdOppor" class="ui icon mini basic button" @click="$refs.showOpportunity.show()">
              <i class="eye blue icon"></i> Estoque: {{ qtdOppor }}
            </button>
          </div>
          <div v-if="item.colors && item.colors.length > 0" class="ui basic segment animated fadeIn">
            <table class="ui very basic selectable celled table">
              <thead class="desktop-only">
                <tr>
                  <th>Cor</th>
                  <th>Quantidade</th>
                  <th>Total</th>
                  <th v-if="userIsSpecial()">P.O. Shipment</th>
                  <th v-if="!item.idReserve"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(color, index) in item.colors" :key="index">
                  <td>
                    {{ color.colorName }}                     
                    <i v-if="color.requireApproval" class="clickable exclamation circle red icon product-details-popup" 
                      data-content="Requer aprovação" data-variation="inverted"></i> 
                  </td>
                  <td><strong class="mobile-only">Quantidade: </strong>{{ $formatInteger(color.quantity) }}</td>
                  <td><strong class="mobile-only">Total: </strong>{{ $formatInteger(color.total) }}</td>
                  <td v-if="userIsSpecial()"><strong class="mobile-only">PO Ship: </strong>{{ $formatInteger(color.poShip) }}</td>
                  <td v-if="!item.idReserve">
                    <button type="button" class="ui mini icon button" @click="onRemoveColor(index)">
                      <i class="times icon"></i>
                    </button>
                  </td>
                </tr>     
                <tr>
                  <td></td>
                  <td></td>
                  <td><strong>{{ $formatInteger(item.quantity) }}</strong></td>
                  <td v-if="!item.idReserve"></td>
                </tr>           
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="eight wide computer sixteen wide tablet sixteen wide mobile column">
        <div id="price-segment" class="ui segment">
          <h4 class="ui dividing header">
            Preço            
            <span v-if="isOwner && item.sugPrice && (Number(item.sugPrice) + 0.001 < Number(item.minPrice))" class="ui small label animated fadeIn">
              <i class="info circle icon"></i>Precisa ser aprovado
            </span>
          </h4>
          <form class="ui form">
            <div class="fields">
              <div class="four wide field">
                <label class="form-label">Quantidade total</label>
                <input :value="$formatInteger(item.quantity)" readonly="readonly">
              </div>
              <div class="four wide field" :class="{ disabled: !canChangePrice }">
                <label class="form-label">Preço Padrão</label>
                <div class="ui action input">
                  <input :value="$formatCurrencyWith4Decimals(item.stdPrice || item.minPrice)" readonly="readonly">
                  <button type="button" class="ui basic icon button product-price-popup" :data-html="stdPricePopupHtml">
                    <i class="search plus blue icon"></i>
                  </button>
                </div>
              </div>
              <div class="four wide field" :class="{ disabled: !canChangePrice }">
                <label class="form-label">Preço sugerido
                  <span class="red text m-r-5">*</span>
                  <span v-if="item.sugPrice">
                    <i v-if="Number(item.sugPrice) + 0.001 >= Number(item.minPrice)" class="check circle green icon"></i>
                    <i v-else class="exclamation circle red icon"></i>
                  </span>
                </label>
                <input class="money-four-dec" :value="sugPrice" @blur="!isApprover ? sugPrice = $event.target.value : null" :readonly="isApprover">
              </div>
              <div class="four wide field" :class="{ disabled: !canChangePrice }">
                <label class="form-label">Total sugerido <span class="red text">*</span></label>
                <input class="money" :value="sugTotal" @blur="!isApprover ? sugTotal = $event.target.value: null" :readonly="isApprover">
              </div>
            </div>
            <div class="fields">
              <div class="eight wide field">
                <label class="form-label">Desconto sugerido</label>
                <span id="input-sug-discount" class="readonly-field" v-html="formatSugDiscount"></span>
              </div>
              <div class="four wide field">
                <label class="form-label">% Comiss. sug.</label>
                <input :value="$formatCurrency(item.sugCommission)" readonly="readonly">
              </div>
              <div class="four wide field" :class="{ disabled: !canChangePrice }">              
                <label class="form-label">Preço aprovado
                  <span class="red text m-r-5">*</span>
                  <span v-if="item.appPrice">
                    <i v-if="Number(item.appPrice) + 0.001 >= Number(item.minPrice)" class="check circle green icon"></i>
                    <i v-else class="exclamation circle red icon"></i>
                  </span>
                </label>
                <input class="money-four-dec" :value="appPrice" @blur="!isOwner ? appPrice = $event.target.value : null" :readonly="isOwner">
              </div>
            </div>
            <div class="fields">
              <div class="four wide field" :class="{ disabled: !canChangePrice }">
                <label class="form-label">Total aprovado</label>
                <input class="money" :value="appTotal" @blur="!isOwner ? appTotal = $event.target.value : null" :readonly="isOwner">
              </div>
              <div class="eight wide field">
                <label class="form-label">Desconto aprovado</label>
                <span id="input-app-discount" class="readonly-field" v-html="formatAppDiscount"></span>
              </div>
              <div class="four wide field" :class="{ disabled: !canChangePrice }">
                <label class="form-label">% Comiss. aprov.</label>
                <input class="money" :value="appCommission" @blur="!isOwner ? appCommission = $event.target.value : null" :readonly="isOwner">
              </div>
            </div>
            <div class="fields">
              <div class="four wide field" :class="{ disabled: !canChangePrice }">
                <label class="form-label">% Diferença</label>
                <input :value="priceDiff" @blur="!isOwner ? priceDiff = $event.target.value : null" :readonly="isOwner" placeholder="0,00">
              </div>
              <div v-if="canSeeRg" class="four wide field" :class="{ disabled: !canChangePrice }">
                <label class="form-label">RG Aprovado</label>
                <div class="ui action input">
                  <input :value="appRg" @blur="!isOwner ? appRg = $event.target.value : null" :readonly="isOwner" placeholder="0,00">
                  <button type="button" class="ui basic icon button product-price-popup" :data-html="rgPopupHtml">
                    <i class="search plus blue icon"></i>
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>

      <div class="sixteen wide column">
        <button class="ui basic button" @click="onCancel()">
          <i class="reply icon"></i> Cancelar
        </button>
        <button v-if="item.idReserve" class="ui red basic button m-l-10" @click="onRemoveReserve(item.branchReserve, item.idReserve)">
          <i class="times icon"></i> Remover reserva
        </button>
        <button class="ui icon right floated blue button" 
          :class="{ disabled: !canConfirm, loading }" @click="onConfirm()">
          <i class="check icon"></i> Confirmar
        </button>
      </div>

    </div>

    <reserve-picker ref="reservePicker" :quotation="quotation" @onSelectReserve="onSelectReserve" />
    <show-opportunity ref="showOpportunity" :customer="selectCustomer" @onSelectReserve="onSelectReserve"/>

  </div>

</template>

<script>

  import { CloseableHeaderLabel, ReservePicker, ShowOpportunity } from "@/components"
  import QuotationService from "@/services/quotation-service"
  import OppBalanceService from "@/services/opp-balance-service"
  import { Input, Message, Scroll } from "@/utils"

  let loadingProducts = false
  let loadingBitolas = false
  let loadingPackages = false
  let loadingPackageMeters = false 

  export default {

    data() {
      return {
        loading: false,      
        item: {},
        selectCustomer: {},
        filter: {
          product: "",
          bitola: "",
          color: "",
        },
        packages: [],
        specialties: [],
        colors: [],
        selectedColor: "",
        selectedColorQuantity: "",
        poShip: "",
        qtdOppor: 0,
        toleranceFieldHasError: false,
      }
    },

    components: {
      CloseableHeaderLabel,
      ReservePicker,
      ShowOpportunity,
    },

    props: ["quotation", "product", "action"],

    computed: {

      isAdding() {
        return (this.action == "add")
      },

      isUpdating() {
        return (this.action == "update")
      },

      isOwner() {
        return (this.$store.state.user.id == this.quotation.idUser)
      },

      isApprover() {
        return (this.$store.state.user.id == this.quotation.idApprover)
      },

      headerLabel() {
        return this.isAdding ? "Adicionar Produto" : "Alterar Produto"
      }, 
      
      infoLabel() {

        if (this.item.amountPackage == null || !this.item.specialty)
          return ""

        let label = ""

        const packageOk = !this.item.isSpecificPackageAmount
        const specialtyOk = (this.item.specialty == "01")

        if (!packageOk && !specialtyOk && !this.item.idReserve) {
          label = "Metragem e especialidade precisam ser aprovadas"
        } else if (!packageOk && !this.item.idReserve) {
          label = "Metragem precisa ser aprovada"
        } else if (!specialtyOk && !this.item.idReserve) {
          label = "Especialidade precisa ser aprovada"
        }

        return label
      },

      canChangeProps() {
        return !this.item.quantity
      },

      canChangePrice() {
        return !!this.item.quantity
      },

      colorsRequireApproval() {

        if (!this.item.colors)
          return false

        let requireApproval = false  

        this.item.colors.forEach((color) => {
          if (color.requireApproval)
            requireApproval = true
        })  

        return requireApproval
      },

      canSeeRg() {
        return QuotationService.canSeeRg()
      },

      formatSugDiscount() {
        // Mod20634-1: sempre exibir desconto sugerido
        if (this.item.stdPrice && Number(this.item.sugPrice) > Number(this.item.stdPrice)) {
          const n = Number(this.item.sugDiscount)
          if (!isNaN(n)) {
            return n < 0
              ? `<span class="red text">${this.item.sugDiscount}</span>`
              : String(this.item.sugDiscount)
          }
        }
        if (this.item.sugDiscTyped) {
          return QuotationService.formatDiscountFromTyped(this.item.sugDiscTyped)
        }
        if (this.item.discountCard || this.item.discountAdditional || this.item.discountExtra) {
          return QuotationService.formatDiscountBold(this.item.discountCard, this.item.discountAdditional, this.item.discountExtra)
        }
        return QuotationService.formatDiscountWithDef(this.item.sugDiscount, this.item.defDiscount)
      },

      formatAppDiscount() {
        // Mod20634-1: sempre exibir desconto aprovado
        if (!this.item.appPrice) return ''
        if (this.item.stdPrice && Number(this.item.appPrice) > Number(this.item.stdPrice)) {
          const n = Number(this.item.appDiscount)
          if (!isNaN(n)) {
            return n < 0
              ? `<span class="red text">${this.item.appDiscount}</span>`
              : String(this.item.appDiscount)
          }
        }
        if (this.item.appDiscTyped) {
          return QuotationService.formatDiscountFromTyped(this.item.appDiscTyped)
        }
        if (this.item.discountCard || this.item.discountAdditional || this.item.discountExtra) {
          return QuotationService.formatDiscountBold(this.item.discountCard, this.item.discountAdditional, this.item.discountExtra)
        }
        return QuotationService.formatDiscountWithDef(this.item.appDiscount, this.item.defDiscount)
      },

      stdPricePopupHtml() {

        let html = ""

        html += `<div><strong>Preço de Tabela: </strong> R$ ${this.$formatCurrencyWith4Decimals(this.item.listPrice)}</div>`
        html += `<div class="m-t-5"><strong>Desc. Padrão: </strong> ${this.item.defDiscount || ''}</div>`

        return html
      },

      rgPopupHtml() {

        let html = ""

        html += `<div><strong>RG Mínimo: </strong> ${this.$formatCurrency(this.item.minRg)}</div>`
        html += `<div class="m-t-5"><strong>RG Sugerido: </strong> ${this.$formatCurrency(this.item.sugRg)}</div>`

        return html
      },

      amountPackage: {
        get() {
          return Input.integerToString(this.item.amountPackage)
        },
        set(value) {
          this.item.amountPackage = Input.stringToInteger(value)
          this.loadColors()
        },
      },

      colorQuantity: {
        get() {
          return Input.integerToString(this.selectedColorQuantity) 
        },
        set(value) {
          this.selectedColorQuantity = Input.stringToInteger(value)
        },
      },

      sugPrice: {
        get() {
          return Input.currencyWith4DecimalsToString(this.item.sugPrice) 
        },
        set(value) {          

          if (this.loading)
            return

          this.calculateSugPrice(Input.stringToCurrency(value))
        },
      },

      sugTotal: {
        get() {
          return Input.currencyToString(this.item.sugTotal) 
        },
        set(value) {

          if (this.loading)
            return

          let sugTotal = Input.stringToCurrency(value)
          let sugPrice = (sugTotal / this.item.quantity)

          sugPrice = parseFloat(sugPrice.toFixed(4))
          
          this.calculateSugPrice(sugPrice)
        },
      },

      appPrice: {
        get() {
          return Input.currencyWith4DecimalsToString(this.item.appPrice) 
        },
        set(value) {

          if (this.loading)
            return

          this.calculateAppPrice(Input.stringToCurrency(value))
        },
      },

      appTotal: {
        get() {
          return Input.currencyToString(this.item.appTotal) 
        },
        set(value) {

          if (this.loading)
            return

          let appTotal = Input.stringToCurrency(value)
          let appPrice = (appTotal / this.item.quantity)

          appPrice = parseFloat(appPrice.toFixed(4))

          this.calculateAppPrice(appPrice)
        },
      },

      appCommission: {
        get() {
          return Input.currencyToString(this.item.appCommission) 
        },
        set(value) {
          this.item.appCommission = Input.stringToCurrency(value)
          this.forceItemUpdate()
        },
      },

      priceDiff: {
        get() {
          return Input.currencyToString(this.item.priceDiff) 
        },
        set(value) {
          
          if (!this.item.sugPrice)
            this.item.sugPrice = 0

          const diffPerc = Input.stringToCurrency(value)
          const diffValue = ((this.item.sugPrice * diffPerc) / 100)	
          const appPrice = (this.item.sugPrice + diffValue)

          this.calculateAppPrice(appPrice)
        },
      },

      appRg: {
        get() {
          return Input.currencyWith4DecimalsToString(this.item.appRg) 
        },
        set(value) {
          
          const appRg = Input.stringToCurrency(value)
          
          this.calculateAppPriceFromRg(appRg)
        },
      },

      poShipment: {
        get() {
          return Input.integerToString(this.poShip) 
        },
        set(value) {
          this.poShip = Input.stringToInteger(value)
        },
      },

      canConfirm() {
        const hasPrice = !!(this.item.sugTotal || this.item.appTotal);
        // Garante que a tolerância não é nula (foi escolhida)
        const hasToleranceValue = this.item.itemAcceptTolerance !== null;
        return hasPrice && hasToleranceValue;
      },
      
      canEditTolerance() {
        return this.item.idPackage === 'B' || this.item.package === 'Bobina';
      },  
    },

    created() {

      if (this.isUpdating)
        this.item = this.$cloneObject(this.product)
    },

    mounted() {
      const { codeCustomer, unitCustomer, nameCustomer } = this.quotation

      this.selectCustomer = {
        code: codeCustomer,
        unit: unitCustomer,
        name: nameCustomer
      }

      Input.maskInteger()
      Input.maskCurrency()

      $("#select-product").dropdown({
        fullTextSearch: true,
        onChange: this.onChangeProduct,
      })

      $("#select-bitola").dropdown({
        fullTextSearch: true,
        onChange: this.onChangeBitola,
      })

      $("#select-package").dropdown({
        fullTextSearch: true,
        onChange: this.onChangePackage,
      })

      $("#select-meters").dropdown({
        fullTextSearch: true,
        onChange: this.onChangeMeters,
      })

      $("#select-specialty").dropdown({
        fullTextSearch: true,
        onChange: this.onChangeSpecialty,
      })

      $("#select-colors").dropdown({
        fullTextSearch: true,
        onChange: this.onSelectColor,
      })

      $(".product-price-popup").popup()

      this.loadProducts()
      
      if (this.isUpdating) {
        this.loadBitolas()
      }  
      
     if (this.isAdding) {
        // Para itens novos, garante que o campo começa nulo
        this.$set(this.item, 'itemAcceptTolerance', null);
     } else {
        // Para itens existentes, corrige inconsistências
        if (this.item.idPackage !== 'B' && this.item.package !== 'Bobina') {
            this.item.itemAcceptTolerance = 'N';
        }
     }

    },

    methods: {

      async loadProducts() {

        this.loading = true
        loadingProducts = true        

        try {

          const { codeCustomer, unitCustomer, isRetail } = this.quotation
          const products = await QuotationService.getProductFamilies(codeCustomer, unitCustomer, isRetail) 

          this.setDropdownValues("#select-product", products) 

          $("#select-product").dropdown("set selected", this.item.codeName || "")
          
        } catch (error) {          
          this.$errorHandler(error)
        }

        this.loading = false
        loadingProducts = false
      },

      async loadBitolas() {

        this.loading = true
        loadingBitolas = true

        try {

          const { codeCustomer, unitCustomer, isRetail } = this.quotation
          const bitolas = await QuotationService.getBitolas(codeCustomer, unitCustomer, this.item.codeName, isRetail) 

          this.setDropdownValues("#select-bitola", bitolas)  

          $("#select-bitola").dropdown("set selected", this.item.codeBitola || "")          

          if (this.item.codeBitola)
            this.loadPackages()

        } catch (error) {
          this.$errorHandler(error)
        }

        this.loading = false
        loadingBitolas = false
      },

      async loadPackages() {

        this.loading = true
        loadingPackages = true        

        try {

          const { codeCustomer, unitCustomer, isRetail } = this.quotation
          const { codeName, codeBitola } = this.item
          const response = await QuotationService.getProductPackages(codeCustomer, unitCustomer, codeName, codeBitola, isRetail) 

          this.packages = response.packages          

          this.setDropdownValues("#select-package", this.packages)  

          $("#select-package").dropdown("set selected", this.item.idPackage || "")          

          this.specialties = response.specialties

          let values = []

          this.specialties.forEach((specialty) => {
            if (!specialty.specificColors)
              this.addDropdownValue(values, specialty.id, specialty.description)
          })

          $("#select-specialty").dropdown("clear")
          $("#select-specialty").dropdown("change values", values)

          if (!this.item.specialty && values.length > 0)
            this.item.specialty = values[0].value

          $("#select-specialty").dropdown("set selected", this.item.specialty)

          if (this.item.idPackage)
            this.loadPackageMeters()

        } catch (error) {          
          this.$errorHandler(error)
        }

        this.loading = false
        loadingPackages = false
      },

      loadPackageMeters() {

        loadingPackageMeters = true

        let values = []

        this.addDropdownEmptyValue(values)

        this.packages.forEach((pack) => {
          if (pack.id == this.item.idPackage)            
            pack.amounts.forEach((amount) => this.addDropdownValue(values, amount.toString(), amount.toString()))
        })

        this.addDropdownValue(values, "ESP", "Outra Metragem")

        let selectedMeters = ""

        if (this.item.amountPackage) {
          selectedMeters = this.item.isSpecificPackageAmount ? "ESP" : this.item.amountPackage          
          this.loadColors()
        }  

        $("#select-meters").dropdown("clear")
        $("#select-meters").dropdown("change values", values)  
        $("#select-meters").dropdown("set selected", selectedMeters)  

        loadingPackageMeters = false
      },

      loadColors() {

        if (!this.item.amountPackage || this.item.amountPackage == 0)
          return

        if (this.specialties.length == 0 || !this.item.specialty)
          return

        if (!this.item.codeName || !this.item.codeBitola || !this.item.idPackage)
          return        
        
        const specificColorId = this.item.codeName + this.item.codeBitola + this.item.idPackage

        this.colors = []

        this.specialties.forEach((specialty) => {
          if (specialty.specificColors && specialty.id === specificColorId)
            this.colors = specialty.colors.slice()
        })

        if (this.colors.length === 0) {
          this.specialties.forEach((specialty) => {
            if (specialty.id === this.item.specialty)
              this.colors = specialty.colors.slice()
          })
        }      

        let values = []

        this.addDropdownEmptyValue(values)

        this.colors.forEach((color) => {

          let value = color.id
          let label = color.description

          if (color.requireApproval)
            label += '<i class="exclamation circle red icon m-l-5"></i>'

          values.push({ value, label, name: label })
        })        

        $("#select-colors").dropdown("clear")
        $("#select-colors").dropdown("change values", values)
        $("#select-colors").dropdown("set selected", "")
      },

      setDropdownValues(id, items) {

        let values = []

        this.addDropdownEmptyValue(values)

        items.forEach((item) => this.addDropdownValue(values, item.id, item.description))

        $(id).dropdown("clear")
        $(id).dropdown("change values", values)
      },

      addDropdownEmptyValue(values) {
        this.addDropdownValue(values, "", "Selecione...")
      },

      addDropdownValue(values, id, label) {
        values.push({
          value: id,
          name: label,
          text: label,
        })
      },

      clearDropdown(id) {
        $(id).dropdown("clear")
        $(id).dropdown("change values", [])
      },

      onChangeProduct(id, label) {

        if (loadingProducts || this.item.codeName == id)
          return
        
        this.item = {}
        this.item.codeName = id
        this.item.name = label
        this.item.codeBitola = ""
        this.item.bitola = ""
        this.selectedColorQuantity  = 0
        this.filter.product = id
        
        this.clearDropdown("#select-bitola")
        this.clearDropdown("#select-package")
        this.clearDropdown("#select-meters")
        this.clearDropdown("#select-specialty")
        this.clearDropdown("#select-colors")
        
        if (this.item.codeName)
          this.loadBitolas()

        this.validReserves()
      },

      onChangeBitola(id, label) {

        if (loadingBitolas || this.item.codeBitola == id)
          return

        const { codeName, name } = this.item

        this.item = {}
        this.item.codeName = codeName
        this.item.name = name
        this.item.codeBitola = id
        this.item.bitola = label    
        this.selectedColorQuantity = 0
        this.filter.bitola = id
        
        this.clearDropdown("#select-package")
        this.clearDropdown("#select-meters")
        this.clearDropdown("#select-specialty")
        this.clearDropdown("#select-colors")

        if (this.item.codeBitola)
          this.loadPackages()

        this.validReserves()
      },

      onChangePackage(id, label) {

        if (loadingPackages || this.item.idPackage == id)
          return

       this.item.idPackage = id
       this.item.package = label
       this.item.amountPackage = null
       this.item.isSpecificPackageAmount = false
       this.selectedColorQuantity  = 0

       this.clearDropdown("#select-colors")

       if (id === 'B' || label === 'Bobina') {
        // É uma bobina, então o usuário DEVE escolher. Resetamos o valor para null.
        this.item.itemAcceptTolerance = null;
        // [NOVO] Ativamos o erro visual imediatamente para guiar o usuário.
        this.toleranceFieldHasError = true;
       } else {
        // NÃO é uma bobina. Não há escolha. O valor é obrigatoriamente 'Não'.
        this.item.itemAcceptTolerance = 'N';
        // [NOVO] Garantimos que o estado de erro seja removido se o pacote deixar de ser bobina.
        this.toleranceFieldHasError = false; 
       }

       this.loadPackageMeters()
      },

      onChangeMeters(value) {

        if (loadingPackageMeters)
          return

        if (!value) {

          this.item.amountPackage = null
          this.item.isSpecificPackageAmount = false

        } else if (value == "ESP") {

          this.item.amountPackage = 0
          if (this.item.idReserve) {
            this.item.isSpecificPackageAmount = false
          } else {
            this.item.isSpecificPackageAmount = true
          }

          setTimeout(() => $("#input-amount-package").focus(), 400)

        } else {

          this.item.amountPackage = parseInt(value)
          this.item.isSpecificPackageAmount = false
        }

        this.selectedColorQuantity  = 0

        this.clearDropdown("#select-colors")

        this.forceItemUpdate()
        this.loadColors()
      },

      onChangeSpecialty(id, label) {

        if (loadingPackages || this.item.specialty == id)
          return

        this.item.specialty = id
        this.item.descSpecialty = label

        this.forceItemUpdate()
      },

      onSelectColor(id) {

        this.selectedColor = id
        this.filter.color = id

        if (this.selectedColor)
          $("#input-color-quantity").focus()

        this.validReserves()
      },

      onAddColor() {

        if (!this.selectedColorQuantity) {
          Message.info("Informe a quantidade")
          return
        }

        let exists = false
        let color = this.getSelectedColor()
        const quantity = this.selectedColorQuantity
        const poShip = this.poShip
        const total = (this.selectedColorQuantity * this.item.amountPackage)

        if (!this.item.colors)
          this.item.colors = []

        this.item.colors.forEach((c) => {
          if (c.colorId == color.id) {
            exists = true
            c.quantity += quantity
            c.total += total
          }
        })

        if (!exists) {
          this.item.colors.push({
            colorId: color.id,
            colorName: color.description,
            requireApproval: color.requireApproval,
            poShip,
            quantity,
            total
          })
        }

        this.selectedColorQuantity  = 0
        this.poShipment = 0

        $("#select-colors").dropdown("set selected", "")

        if (this.item.sugPrice) {
          this.updateItemTotals()
        } else {
          this.calculateSugPrice()
        }
      },      

      getSelectedColor() {

        let color = null

        this.colors.forEach((c) => {
          if (c.id == this.selectedColor)
            color = this.$cloneObject(c)
        })

        return color
      },

      onRemoveColor(index) {

        this.item.colors.splice(index, 1)

        if (this.item.colors.length == 0) {
          this.clearPriceData()
        } else {
          this.updateItemTotals()
        }
      },

      clearPriceData() {

        this.item.quantity = 0
        this.item.listPriceId = ""
        this.item.listPrice = 0
        this.item.defDiscount = ""
        this.item.cashPaymentDiscount = 0
        this.item.freightDiscount = 0
        this.item.minPrice = 0
        this.item.minRg = 0
        this.item.sugPrice = 0
        this.item.sugTotal = 0
        this.item.sugRg = 0
        this.item.sugDiscount = ""
        this.item.sugCommission = 0
        this.item.appPrice = 0
        this.item.appTotal = 0
        this.item.appRg = 0
        this.item.appDiscount = ""
        this.item.appCommission = 0
        this.item.priceDiff = 0

        this.forceItemUpdate()
      },

      async calculateSugPrice(sugPrice) {

        this.loading = true

        this.updateItemTotals()

        try {

          let item = await QuotationService.calculateSugPrice(this.quotation, this.item, sugPrice)

          this.item = this.$cloneObject(item)

          // Primeira carga (sem sugPrice): recalcular com o preco retornado para obter desconto correto
          if (!sugPrice && this.item.sugPrice) {
            this.updateItemTotals()
            item = await QuotationService.calculateSugPrice(this.quotation, this.item, this.item.sugPrice)
            this.item = this.$cloneObject(item)
          }

          $("#input-sug-discount").focus()

        } catch (error) {

          this.$errorHandler(error)

        } finally {

          this.loading = false
        }
      },

      async calculateAppPrice(appPrice) {

        this.loading = true     

        this.updateItemTotals()

        try {

          const item = await QuotationService.calculateAppPrice(this.quotation, this.item, appPrice)          

          this.item = this.$cloneObject(item)

          $("#input-app-discount").focus()

        } catch (error) {
          
          this.$errorHandler(error)          
        
        } finally {
          
          this.loading = false
        }
      },

      async calculateAppPriceFromRg(rg) {

        this.loading = true     

        try {

          const { codeCustomer, unitCustomer, isRetail } = this.quotation

          const appPrice = await QuotationService.getPriceFromRg({
            codeCustomer,
            unitCustomer,
            isRetail,
            rg,
            item: this.item,
          })

          await this.calculateAppPrice(appPrice)

        } catch (error) {
          this.$errorHandler(error)
        }

        this.loading = false
      },

      updateItemTotals() {

        this.item.quantity = 0

        this.item.colors.forEach((color) => this.item.quantity += color.total)

        this.item.sugTotal = (this.item.quantity * this.item.sugPrice)
        this.item.appTotal = (this.item.quantity * this.item.appPrice)

        this.forceItemUpdate()
      },

      forceItemUpdate() {
        this.item = this.$cloneObject(this.item)
      },

      async onConfirm() {
         // INÍCIO DA MODIFICAÇÃO
        this.toleranceFieldHasError = false;
        if (this.item.itemAcceptTolerance === null) {
          Message.error("O campo 'Aceita Tolerância' é obrigatório. Por favor, selecione uma opção.");
          this.toleranceFieldHasError = true;
          
          this.$nextTick(() => {
            Scroll.toElement("#select-tolerance");
            $("#select-tolerance").parent('.dropdown').focus();
          });
          return; // Bloqueia o salvamento
        }
        // FIM DA MODIFICAÇÃO
        
        this.loading = true

        try {

          await QuotationService.validItem(this.item, this.quotation.codeCustomer, this.quotation.unitCustomer)

          QuotationService.updateItemData(this.item)

          this.forceItemUpdate()

          this.$emit("onConfirm", this.$cloneObject(this.item))
          
        } catch (error) {
          
          this.$errorHandler(error)

        } finally {

          this.loading = false
        }                
      },

      onCancel() {
        this.$emit("onCancel")
      },

      async onSelectReserve(reserve) {

        const balance = reserve.balance
        const product = balance.product
        const meters = (balance.total / balance.quantity)
        const code = product.code.trim()

        if (this.item.colors) {
          await OppBalanceService.cancel(balance.branch.id, reserve.id)
          Message.info("Inclua a reserva como um novo item")
          return
        }

        this.item.name = product.name
        this.item.codeName = product.codeName
        this.item.bitola = product.bitola
        this.item.codeBitola = product.codeBitola                
        this.item.specialty = code.substring(code.length - 2)
        this.item.amountPackage = meters

        this.item.colors = []

        this.item.colors.push({
          colorId: product.codeColor, 
          colorName: product.color, 
          quantity: balance.quantity, 
          total: balance.total,
          // idReserve: reserve.id
        })

        this.updateItemTotals()
        this.setReservePack(reserve)    
        
        this.item.description = QuotationService.getItemDescription(this.item)    
        this.item.branchReserve = this.quotation.customer.billBranch
        this.item.idReserve = reserve.id    

        if (this.isOwner) {
          
          this.calculateSugPrice(this.item.sugPrice || 0)

        } else if (this.isApprover) {
          
          this.calculateAppPrice(this.item.appPrice || 0)
        }
      },

      setReservePack(reserve) {

        let address = reserve.balance.address.toUpperCase().trim()

        this.item.idPackage = ""
        this.item.package = ""

        if (address.indexOf("BLISTER") > -1) {

          this.item.idPackage = "L"
          this.item.package = "Blister"

        } else if (address.indexOf("MADEIRA") > - 1) {

          this.item.idPackage = "M"
          this.item.package = "Carretel Madeira"

        } else if (address.indexOf("PLASTICO") > - 1) {

          this.item.idPackage = "C"
          this.item.package = "Carretel Plastico"

        } else if (address.indexOf("RETALHO") > - 1) {

          this.item.idPackage = "T"
          this.item.package = "Retalho"
          
        } else if (address.indexOf("ROLO") > - 1) {
          
          this.item.idPackage = "R"
          this.item.package = "Rolo"

        } else if (address.indexOf("BOBINA") > - 1) {
          
          this.item.idPackage = "B"
          this.item.package = "Bobina"
        }	
        this.item.itemAcceptTolerance = (this.item.idPackage === 'B') ? 'N' : 'N';
      },

      async onRemoveReserve(idBranch, idReser) {
        try {
          await OppBalanceService.cancel(idBranch, idReser)
          Message.success("Reserva cancelada com sucesso")              
        } catch (error) {
          this.$errorHandler(error)
        }

        this.item = {}
        this.loadProducts()
        Scroll.toElement("#quotation-products")
      },

      validReserves() {
        if (this.filter.product && this.filter.bitola && this.filter.color) {
          this.getOpportunity()
        }
      },

      getOpportunity() {
        this.$store.commit("setBalancesFilter", this.$cloneObject(this.filter))

        let data = {
          productName: this.filter.product,
          productBitola: this.filter.bitola,
          productColor: this.filter.color,
          customerCode: "",
          customerUnit: "",
          isProspect: false,
        }

        if (data.productColor == "*")
          data.productColor = ""

        if (this.$isCustomerOrProspect()) {

          data.customerCode = this.$store.state.user.customer.code
          data.customerUnit = this.$store.state.user.customer.unit
          data.isProspect = this.$store.state.user.customer.isProspect

        } else if (this.filter.customer) {

          data.customerCode = this.filter.customer.code
          data.customerUnit = this.filter.customer.unit
          data.isProspect = this.filter.customer.isProspect
        }

        this.onSearch(data)
      },

      async onSearch(filter) {

        if (this.loading)
          return
        
        this.loading = true

        try {

          const balances = await OppBalanceService.searchBalances(filter)

          this.$store.commit("setBalances", balances)

          this.loading = false

          this.qtdOppor = balances.length
          
        } catch (error) {
          
          this.loading = false

          this.$errorHandler(error)
        }
      },

      userIsSpecial () {
        return this.$store.state.user.group == '09'
      }
    },
  }

</script>
